import './Authorize.css';
import { ElementType, LayoutResponse, StateResponse, StatusEnum } from './services/types';
import Title from './components/Title';
import { DEFAULT_BACKGROUND, DEFAULT_FONT_COLOR, TITLE } from './uiConstants';
import FallbackLogo from './assets/fallbackLogo.svg';
import { useEffect, useRef, useState } from 'react';
import { checkState } from './services/requests';
import Button from './components/Button';

interface Props {
    state: string | null,
    redirectUri: string | null,
    onError: (errorType?: string) => void,
    layout: LayoutResponse[];
}

const WAIT_TIME_SEC = 5;
const Authorize = ({ state, redirectUri, onError, layout }: Props) => {

    const [repeatCount, setRepeatCount] = useState(Math.floor(600 / WAIT_TIME_SEC)); //total sec 600  - 10 min
    const countDownRef = useRef(repeatCount);

    const fontColor = layout.find(p => p.elementType === ElementType.FONT_COLOR)?.elementHtml || DEFAULT_FONT_COLOR;
    const bgColor = layout.find(p => p.elementType === ElementType.BACKGROUND_COLOR)?.elementHtml || DEFAULT_BACKGROUND;

    const title = layout.find(p => p.elementType === ElementType.TITLE)?.elementHtml || TITLE;
    const logo = layout?.find(p => p.elementType === ElementType.LOGO)?.elementHtml || undefined;



    const query = new URLSearchParams(window.location.search)
    const acr_values = query.get('acr_values');
    const scope = query.get('scope');

    //Manual refresh every 5 sec for smoother status update
    useEffect(() => {
        if (!state) {
            return;
        }
        const timerId = setInterval(async () => {
            countDownRef.current -= 1;
            if (countDownRef.current <= 0) {
                clearInterval(timerId);
                onError('login_required');
            }
            else {
                const result = await checkState(state);
                if (!!result?.status) {
                    clearInterval(timerId);
                    processResult(result);

                }
                else { setRepeatCount(countDownRef.current); }
            }
        }, WAIT_TIME_SEC * 1000); //run every 5msec
        return () => {
            clearInterval(timerId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    const processResult = async (confirmStatus: StateResponse) => {
        try {


            if (confirmStatus?.status === StatusEnum.APPROVED && !!confirmStatus?.code) {
                const redirect = `${redirectUri}?code=${confirmStatus.code}&state=${state}&acr_values=${acr_values}&scope=${scope}`;
                window.location.replace(redirect);
            }
            else if (confirmStatus?.status === StatusEnum.DECLINED) {
                onError('login_required');
            }
            else { onError('server_error'); }
        }
        catch (e) {
            console.log('error', e);
            //  onError('server_error');
        }
    };

    return (<>
        {logo && <img
            className='logo-box'
            alt='Logo'
            src={`data:image/svg+xml;utf8,${encodeURIComponent(logo)}`}
            onError={(e) => (e.currentTarget.src = FallbackLogo)} />}
        <Title color={fontColor}>{title}</Title>
        <Button color={fontColor} bgColor={bgColor} onClick={() => onError('login_required')}>Cancel</Button>
    </>
    );
}

export default Authorize;
